<!-- 组合推荐组件 -->
<template>
  <div class="combination-recommendation">
    <div class="container container--normal container--xs-normal mb-20" v-if="initConfig&&initConfig.image">
      <!-- 移动端的组合推荐标题 -->
      <div class="mb-title">{{initConfig.title}}</div>
      <div class="combination-recommendation__content">
        <!-- 组合推荐的大图 -->
        <div class="combination-recommendation__compose">
          <v-compose-image 
            :tags-config="initConfig"
            :current-product-id='currentProductID'
            :products="productList"
            @changeCurrentProductId="changeCurrentProductId"
          ></v-compose-image>
        </div>
        <!-- 组合推荐的商品卡片swiper -->
        <div class="combination-recommendation__swiper">
          <v-swiper-product-card 
            :products="productList" 
            :title="initConfig.title" 
            :comment="comment"
            :current-product-id="currentProductID"
            :palette-config="paletteConfig"
          ></v-swiper-product-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VComposeImage from './ComposeImage.vue'; 
import VSwiperProductCard from  './SwiperProductCard.vue';

export default {
   name: "CombinationRecommendation",
   components: {
      VComposeImage,
      VSwiperProductCard,
   },
   props: {
    //评论模块的数据
    comment: { 
      type: Object,
      default: null
    },
    //模块的数据
    moduleConfig: {
      type: Object,
      default: {},
    },
    //调色板模块的数据
    paletteConfig:{
      type: Object,
      default: null
    }
   },
   data() {
     return {
       currentProductID: null, //当前swiper显示的商品id。例: 000001 
       productsIds: [], //在大图设置锚点的商品id列表，用于获取接口的params。例:[{product_id:000001}]
       productList: [], //通过接口获取的商品数据列表。
     }
   },
   computed: {
     //获取组合推荐的配置
     ...mapState({
       initConfig({}){
         return this.moduleConfig
       }
     }),
   },
  methods: {
    //通过/api/store/products/search获取对应id的商品数据
    async getProductList(productsids) {
      let params = {
        "include_id": productsids
      };
      try {
        let res = await this.$axios.post('/api/store/products/search',params);
        if (res && res.data) {
          this.productList = res.data.data??[]
        } else {
          this.productList = []
        }
      } catch (error) {
      }
    },
    //设置当前swiper显示的商品id
    changeCurrentProductId(data) {
      this.currentProductID = data
    }
  },
  beforeMount(){
    //this.currentProductID = this.initConfig.img_tag[0].product_id
    this.initConfig.img_tag?.forEach(el => {
      this.productsIds.push({product_id:el.product_id})
    });
    this.getProductList(this.productsIds)
  },
}
</script>

<style  lang="scss" scoped>
.mb-title{
  display: none;
}
.combination-recommendation {
  &__content {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 60px 0px;
  }
  &__compose{
    width: 50%;
    max-width: 50%;
  }
  &__swiper{
    width: 50%;
    max-width: 50%;
  }
}
@media (max-width: 767px) {
  .container{
    margin: 0px;
    padding: 0px;
    .mb-title{
      display: block;
      font-size: 30px;
      font-family: Tenor Sans;
      font-weight: bold;
      color: #222A40;
      height: 50px;
      text-align: center;
    }
    .combination-recommendation {
      &__content {
        flex-direction: column;
        margin: 0px; 
      }
      &__compose,&__swiper{
        width: 100%;
        max-width: 100%;
      }
    }
  }
}
</style>